import React, { useState, useRef, useEffect } from 'react';
import { FiX, FiStar } from 'react-icons/fi';
import './DemoFeedbackModal.css';
import axios from 'axios';

const DemoFeedbackModal = ({ feedback, onClose, onSubmitSuccess }) => {
  const [formData, setFormData] = useState({
    IdClassStatus: 0, // Default to "Class Completed"
    IdClass: 1, // Default to first project (1-5)
    ParentsAvailable: false,
    Rating: 0,
    Details: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const modalRef = useRef();

  // Project options mapped to IDs 1-5
  const projectOptions = [
    { id: 1, name: 'Angry Birds (Little)' },
    { id: 2, name: 'Flappy Bird' },
    { id: 3, name: 'Fish Aquarium' },
    { id: 4, name: 'Ecommerce' },
    { id: 5, name: 'Chat Bot' }

  ];

  const classStatusOptions = [
    { value: 0, label: 'Class Completed' },
    { value: 1, label: 'Student Not Joined' },
    { value: 2, label: 'Student Left Early' },
    { value: 3, label: 'Student Not Interested' }
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitError(null);

    try {
        

          if (formData.IdClassStatus===0 && !formData.IdClass) {
            throw new Error('Please select a project');
          }
          if (formData.IdClassStatus===0 && formData.Rating === 0) {
            throw new Error('Please provide a class rating');
          }
          if (formData.IdClassStatus===0 && !formData.Details.trim()) {
            throw new Error('Notes are required');
          }    
      const submissionData = {
        ClassDateTime: feedback.ClassDateTime,
        IdClass: formData.IdClassStatus === 0 ? formData.IdClass : 0,
        IdSchedule: feedback.IdSchedule,
        IdTeacher: feedback.IdTeacher,
        IdStudent: feedback.IdStudent,
        IdClassStatus: formData.IdClassStatus,
        ParentsAvailable: formData.IdClassStatus === 0 ? (formData.ParentsAvailable ? 1 : 0) : 0,
        Rating: formData.IdClassStatus === 0 ? formData.Rating : 0,
        Details: formData.Details
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/teacher/submitdemoform`,
        submissionData
      );

      onSubmitSuccess();
      onClose();
    } catch (error) {
      console.error('Error submitting demo feedback:', error);
      setSubmitError(error.response?.data?.error || error.message || 'Failed to submit feedback');
    } finally {
      setIsSubmitting(false);
    }
  };

  const isCompleted = formData.IdClassStatus === 0;

  return (
    <div className="modal-overlayDemo">
      <div className="modal-content" ref={modalRef}>
        <div className="modal-header">
          <h3>Submit Demo Feedback</h3>
          <button onClick={onClose} className="close-btn">
            <FiX />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Class Status *</label>
            <select
              name="IdClassStatus"
              value={formData.IdClassStatus}
              onChange={(e) => setFormData({...formData, IdClassStatus: parseInt(e.target.value)})}
              className="form-select"
              required
            >
              {classStatusOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          {isCompleted && (
            <>
              <div className="form-group">
                <label>Project *</label>
                <select
                  name="IdClass"
                  value={formData.IdClass}
                  onChange={(e) => setFormData({...formData, IdClass: parseInt(e.target.value)})}
                  className="form-select"
                  required
                >
                  {projectOptions.map(project => (
                    <option key={project.id} value={project.id}>
                      {project.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Rating (1-5)</label>
                <div className="rating-stars">
                  {[1, 2, 3, 4, 5].map(star => (
                    <FiStar
                      key={star}
                      className={`star ${star <= formData.Rating ? 'filled' : ''}`}
                      onClick={() => setFormData({...formData, Rating: star})}
                    />
                  ))}
                </div>
              </div>

              <div className="form-group">
                <label>
                  <input
                    type="checkbox"
                    name="ParentsAvailable"
                    checked={formData.ParentsAvailable}
                    onChange={(e) => setFormData({...formData, ParentsAvailable: e.target.checked})}
                  />
                  Contacted Parents?
                </label>
              </div>
            </>
          )}

          <div className="form-group">
            <label>Notes</label>
            <textarea
              name="Details"
              value={formData.Details}
              onChange={(e) => setFormData({...formData, Details: e.target.value})}
              className="form-textarea"
              placeholder="Additional notes..."
            />
          </div>

          {submitError && <div className="error-message">{submitError}</div>}

          <div className="form-actions">
            <button type="submit" className="submit-btn" disabled={isSubmitting}>
              {isSubmitting ? 'Submitting...' : 'Submit Feedback'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DemoFeedbackModal;